import { DateTime } from 'luxon';

export const months = [
    'enero',
    'febrero',
    'marzo',
    'abril',
    'mayo',
    'junio',
    'julio',
    'agosto',
    'septiembre',
    'octubre',
    'noviembre',
    'diciembre',
];

export const days = [
    'domingo',
    'lunes',
    'martes',
    'miércoles',
    'jueves',
    'viernes',
    'sábado',
];

/**
 * Obtains the name of the first day of the specified month.
 *
 * @param {number} year - The year.
 * @param {number} month - The month.
 * @param {number|undefined} day - The day.
 * @returns {string} The name of the day of the month.
 */
export function getDayNameFromDate (year, month, day) {
    const errors = [];
    if (year === undefined) errors.push('Invalid parameters. Year is required.');
    if (month === undefined) errors.push('Invalid parameters. Month is required.');
    if (day === undefined) errors.push('Invalid parameters. Day is required.');

    // Validate that the parameters are numbers
    if (typeof year !== 'number' || typeof month !== 'number' || typeof day !== 'number')
        errors.push('Invalid parameters. The parameters must be numbers. The parameters types given were: ' + JSON.stringify({ year: typeof year, month: typeof month, day: typeof day }));

    if (errors.length > 0) {
        throw new Error(errors.join('\n'));
    }

    // Create a date with the first day of the given month
    const fecha = DateTime.local(year, month, day).setLocale('es');

    // Get the week day full name
    const primerDia = fecha.toFormat('cccc');

    return primerDia;
};


export function daysOfMonth (year, month) {
    const errors = [];
    if (year === undefined) errors.push('Invalid parameters. Year is required.');
    if (month === undefined) errors.push('Invalid parameters. Month is required.');

    // Validate that the parameters are numbers
    if (typeof year !== 'number' || typeof month !== 'number')
        errors.push('Invalid parameters. The parameters must be numbers. The parameters types given were: ' + JSON.stringify({ year: typeof year, month: typeof month }));

    if (errors.length > 0) {
        throw new Error(errors.join('\n'));
    }

    // Create a date with the first day of the given month
    const fecha = DateTime.local(year, month).endOf('month');

    // Get the number of days in the month
    const ultimoDia = fecha.toFormat('d');

    return ultimoDia;
}
